import {v4 as uuidv4} from 'uuid';
import fetchConfig from './fetchConfig';
// import {setupCache} from "axios-cache-interceptor";

// const axios = setupCache(Axios)

const get = async (url, raw) => {
  const token = sessionStorage.getItem('kctoken');
  const request = await fetch(fetchConfig.baseUrl + url, {
    headers: { Authorization: `Bearer ${token}` },
    Accept: 'application/json',
    'Content-Type': 'application/json',
  });
  const response = await request.json();
  if (raw) {
    return request.ok
        ? Promise.resolve(response)
        : Promise.reject(response?.error?.message ?? 'Произошла ошибка');
  }

  return response;
};



const post = async (url, body,raw=false) => {
  const token = sessionStorage.getItem('kctoken');
  const req = await fetch(fetchConfig.baseUrl + url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  const response = await req.json();
  if (raw) {
    return req.ok
        ? Promise.resolve(response)
        : Promise.reject(response?.error?.message ?? 'Произошла ошибка');
  }

  return response;
};

const put = async (url, body) => {
  const token = sessionStorage.getItem('kctoken');
  const req = await fetch(fetchConfig.baseUrl + url, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  const response = await req.json();
  return req.ok
    ? Promise.resolve(response)
    : Promise.reject(response?.error?.message ?? 'Произошла ошибка');
};

// const postWithPromise = async (url, body) => {
//   const token = sessionStorage.getItem('kctoken');
//   const req = await fetch(fetchConfig.baseUrl + url, {
//     method: 'POST',
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(body),
//   });
//   const res = await req.json();
//   if (!req.ok) {
//     await Promise.reject(res?.error?.message ?? 'Произошла ошибка');
//   }
//   return res;
// };

const postFormData = async (url, body, file, {fileFieldName,raw,isJsonValue}={}) => {
  [fileFieldName,raw,isJsonValue] = [fileFieldName ?? 'doc',raw ?? false,isJsonValue ?? false]
  const token = sessionStorage.getItem('kctoken');
  const formData = new FormData();
  if (file){
    Array.isArray(file) ? file.forEach(el=>formData.append(fileFieldName,el)) : formData.append(fileFieldName,file)
  }
  for (const [key, value] of Object.entries(body)) { formData.append(key, isJsonValue ? JSON.stringify(value) : value); }
  const req = await fetch(fetchConfig.baseUrl + url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const response = await req.json();
  if (raw) {
    return req.ok
        ? Promise.resolve(response)
        : Promise.reject(response?.error?.message ?? 'Произошла ошибка');
  }

  return response;
};

const postProjAttachments = async (url, attachments, fileFieldName = 'docs') => {
  const token = sessionStorage.getItem('kctoken');
  const formData = new FormData();
  const fileDictionary = {};
  for (const attachment of attachments.filter((v) => !v.id)) {
    const UUID = uuidv4();
    fileDictionary[attachment.file.name.concat(UUID)] = attachment.fileName;
    formData.append(fileFieldName, attachment.file, attachment.file.name.concat(UUID));
  }
  formData.append('fileDictionary', JSON.stringify(fileDictionary))
  const req = await fetch(fetchConfig.baseUrl + url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  return req;
};

const postFiles = async (url, files, fileFieldName = 'docs') => {
  const token = sessionStorage.getItem('kctoken');
  const formData = new FormData();
  files.forEach((file) => formData.append(fileFieldName, file))
  const req = await fetch(fetchConfig.baseUrl + url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  return req;
}

const postFileFixed = async (url, body, file, fileFieldName = 'doc') => {
  const token = sessionStorage.getItem('kctoken');
  const formData = new FormData();
  formData.append(fileFieldName, file);
  for (const [key, value] of Object.entries(body)) {
    if (key === 'tags') { formData.append(key, JSON.stringify(value)); } else { formData.append(key, value); }
  }
  const req = await fetch(fetchConfig.baseUrl + url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const res = await req.json();

  return res;
};



const putResponseText = async (url, body) => {
  const token = sessionStorage.getItem('kctoken');
  const req = await fetch(fetchConfig.baseUrl + url, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  const res = req.text();

  return res;
};

const del = async (url, body) => {
  const token = sessionStorage.getItem('kctoken');
  const req = await fetch(fetchConfig.baseUrl + url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  const res = await req.json();

  return res;
};

const delWithPromise = async (url, body) => {
  const token = sessionStorage.getItem('kctoken');
  const req = await fetch(fetchConfig.baseUrl + url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  const res = await req.json();
  if (!req.ok) {
    await Promise.reject(res?.error?.message ?? 'Произошла ошибка');
  }

  return res;
};

const download = async (url, filename) => {
  const token = sessionStorage.getItem('kctoken');
  const resp = await fetch(fetchConfig.baseUrl + url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (resp.ok) {
    if (resp.headers.get('Content-Type') === 'application/octet-stream') {
      const blob = await resp.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileNameHeader = resp.headers.get('fileName');
      link.download = fileNameHeader
        ? decodeURIComponent(fileNameHeader)
        : filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(link);
      }, 200);
      return { success: true };
    }
    return { error: { message: 'Получен неверный тип данных' } };
  }
  const error = resp.headers.get('Content-Type').indexOf('application/json') >= 0 ? (await resp.json()) : {};
  return { error };
};

export default {
  get,
  post,
  postFormData,
  postProjAttachments,
  putResponseText,
  del,
  delWithPromise,
  download,
  postFileFixed,
  postFiles,
  put,
};
